import { useState } from "react";
import { resortLogos } from "../../../shared/mountains";
import "./outdoors.css";

/** The resort's logo, else its site icon, else a monogram when the icon is too small to look right. */
export function ResortLogo({ r }: { r: { id: string; name: string; report: string } }) {
  const sources = resortLogos(r);
  const [i, setI] = useState(0);
  const logo = sources[i];
  if (!logo) {
    const initials = r.name.split(/[\s-]+/).map((w) => w[0]).join("").slice(0, 2).toUpperCase();
    return (
      <span className="mtn-logo mtn-monogram" aria-hidden="true">
        {initials}
      </span>
    );
  }
  return (
    <img
      className={`mtn-logo ${logo.icon ? "is-icon" : "is-wordmark"}`}
      src={logo.src}
      alt=""
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => setI((n) => n + 1)}
      // Google returns its 16 px icon when a site has nothing bigger; that blurs at this size.
      onLoad={(e) => logo.icon && e.currentTarget.naturalWidth < 40 && setI((n) => n + 1)}
    />
  );
}
